export default __webpack_public_path__ + "img/glp_preview-99cc43f3cd738a1408ca261f21d51a32.png";